import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const propyleneOxideHardRule = {
    id: StowageRuleId.PropyleneOxideHardRule,
    name: 'IBC 15.8 Propylene Oxide Hard Rule: a cargo with IBC requirement 15.8 cannot be stowed in a tank not compatible with IBC 15.8.',
    lastUpdatedUtc: '2014-05-15T13:24:00',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Product category specific and operational requirements',
                            fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                            type: 'array',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'IBC chapter 15.8',
                            type: 'string',
                            referenceValue: 'IBC-15.8',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Contains,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank property ibcCompatibilities',
                            fieldPath: 'tank.ibcCompatibilities',
                            type: 'array',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'IBC chapter 15.8',
                            type: 'string',
                            referenceValue: 'IBC-15.8',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.DoesNotContain,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'According to IBC 15.8, Propylene Oxide cannot be carried in this tank.',
    },
} as StowageRuleBM;
